import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { consts } from '@src/constants/consts';
import { DialogManagerService } from '@src/services';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EnvSettingDialog } from '@app/shared/components/dialogs/environment-setting-dialog/environment-setting-dialog.component';
import { Store } from '@src/store';


@Component({
    selector: 'environments-rotator',
    template: require('./environmentsRotator.html'),
    styles: [require('./environmentsRotator.scss')]
})

export class EnvironmentsRotatorComponent {


    @Input() public isSuperUser;
    @Input() public environments
    @Input() public envTypeName;
    @Input() public prevEnvironmentType;
    @Input() public connectToSourceControl;
    @Input() public isRmsource
    @Input() set selectAutoEnv(data) {
        if (data) {
            this.handleEnvironmentClicked(data);
            this._selectAutoEnv = data;
        }

    };
    @Input() public superUser
    @Input() set hasSuperUser(value) {
        this._hasSuperUser = value;
    }
    public rmSchemas: any;
    public orderRMid: any;
    public _environment: any;
    public _selectAutoEnv: any;
    public databaseType: any;
    public superUser2;
    @Input() set rmsourceSchemas(value) {
        this.rmSchemas = value;
        this._rmsourceSchemas = value;
    }
    @Output() public onRemoveSchema = new EventEmitter();
    @Output() public onSelectEnvironment = new EventEmitter();
    @Output() public checkingConnector = new EventEmitter();
    @Output() public onRemoveEnvironment = new EventEmitter();
    //@Output() public onReplaceSchemaOfRm = new EventEmitter();
    @Output() public onTest = new EventEmitter();
    set environment(value) {
        this._environment = value;
        if (this._environment) {
            //schemas4UIView = an array that is used only for the UI in order to present placeholders for missing schemas
            this._environment.schemas4UIView = this.setOrder(this._environment?.schemas);
            this._environment.schemas = this._environment.schemas4UIView?.filter(s => s.id != -1);
            this._environment.schemas4UIView = this._environment.schemas4UIView?.filter(s => !s.isSuperUser);

        }
    };
    public hasVersionToR: any;
    public index: number = 0;
    public selectedEnvironment
    public _rmsourceSchemas: any;
    public dataT: string;
    public _hasSuperUser: any;
    public readonly ENV_TYPES = consts.envTypes;
    constructor(
        @Inject('$filter') public $filter: any, @Inject('$state') public state: any, @Inject('$scope') public $scope: any, public store: Store, public dialogManagerService: DialogManagerService
    ) {
        this.databaseType = this.state.params.dbType
        if (!this.databaseType) {
            this.databaseType = this.store.getState().project.data.dbTypeId;
        }
        this.dataT = this.$filter('dbTypeItem')(["Schemas"], this.state.params.dbType)
    }
    ngOnInit() {

        this.hasVersionToR = this.environment && this.environment.IsRMSource && this.environment.hasVersion ? true : false;
        this.superUser2 = (item) => {
            if (item.isSuperUser) {
                this.environment.hasSuperUser = true;
            }
            return item.isSuperUser === false
        };
        this.environment = this.selectedEnvironment;
        if (this.environments != null && this.environments.length > 0) {
            this.environments.find(env => { return env.envSelected; }) ?
                this.environments.find(env => { return env.envSelected; }).envSelected = false
                :
                this.handleEnvironmentClicked(this.environments[0]);
        }

        this.$scope.$watch(() => this.envTypeName, () => {
            if (this.environments != null && this.environments.length > 0) {
                this.environments.find(env => { return env.envSelected; }) ?
                    this.environments.find(env => { return env.envSelected; }).envSelected = false
                    :
                    this.handleEnvironmentClicked(this.environments[0]);
            }
        })
        this.rmSchemas = this._rmsourceSchemas;
        this.$scope.$watch(() => this.selectedEnvironment, () => {
            this.environment = this.selectedEnvironment;
            this.rmSchemas = this._rmsourceSchemas;
        });

        //if RS is not the selected env, need to update its Schemas4UIView
        if (this.prevEnvironmentType && this.prevEnvironmentType.id == this.ENV_TYPES.Release_Source) {
            this.prevEnvironmentType.environments[0].schemas4UIView = this.prevEnvironmentType.environments[0].schemas;
        }

    }

    get hasSuperUser() {
        return this._hasSuperUser;
    }


    onSuperUser(data) {
        const _this = this;
        if (!data.schemas)
            data.schemas = [];
        var schema = data.schemas.filter(item => item.isSuperUser == true)[0];
        var superUserIsExists = false;
        if (schema)
            superUserIsExists = true;
        else
            schema = {};

        let con = { host: '', userName: '', password: '', port: '1521', safe: '', folder: '', object: '' };
        if (schema && schema.connectionProperties)
            con = { ...schema.connectionProperties };

        if (data) {
            this.store.dispatch({
                type: 'GET_CONN_TEMPLATE',
                payload: { dbTypeId: this.databaseType, manageOrUnmanage: 'managed' }
            }).then(res => {
                let htmlConn = res.htmlTemplate;
                this.dialogManagerService.showDBConnectionDialog(
                    htmlConn,
                    {
                        title: 'Add Super User',
                        buttons: [
                            { text: 'Save', onClick: (instance, onClose) => { onClose(instance.data); } },
                            { text: 'Cancel', onClick: (_, onClose) => { onClose(); } }
                        ],
                        setData: (instance) => {
                            instance.data = {
                                connectionProperties: con,
                                dbType: this.databaseType,
                                hasVersionToRm: this.hasVersionToR,
                                testButton: {
                                    value: 'Test Connection', onClick: data => {
                                        data.schema = schema;
                                        this.onTest.emit({ connectionProperties: data, isTest: true });
                                    }
                                },
                                switchTab: (data, tab) => {
                                    con = data.connectionProperties;
                                    _this.store.dispatch({
                                        type: 'SWITCH_TAB',
                                        payload: { dbTypeId: _this.databaseType, connectionProperties: con }
                                    }).then(res => {
                                        if (res) {
                                            data.connectionProperties = res;
                                            data.connectionProperties.lastVisit = tab;
                                        }
                                    });
                                }
                            }
                        }
                    },
                    (_data) => {
                        /*if (_data.connectionType.name != 'CyberArk') {
                            _data.connectionProperties.folder = null;
                            _data.connectionProperties.safe = null;
                            _data.connectionProperties.object = null;
                        } else {
                            _data.connectionProperties.password = '';
                        }*/
                        schema.isSuperUser = true;

                        //schema.connectionProperties = _data.connectionProperties;
                        //schema.schemaName = schema.connectionProperties.userName;

                        schema.schemaName = _data.connectionProperties.dbName || _data.connectionProperties.userName;
                        schema.name = schema.schemaName;
                        //change the authType to be correct after the change instead of ng-init data.connectionProperties.authType = data.authType.id
                        _data.connectionProperties.authType = _data.authType.id.toString();
                        schema.connectionProperties = _data.connectionProperties;



                        if (!superUserIsExists) {
                            schema.schemaId = 0;
                            schema.tempSchemaId = null;
                            schema.schemaName = schema.connectionProperties.userName;
                            schema.envId = 0;
                            schema.tempEnvId = null;
                            schema.schemaMap = null;
                            schema.parentId = null;
                            schema.isManaged = false;
                            schema.isAssigned = false;
                            schema.dbId = null;
                            schema.dbName = schema.schemaName;
                            schema.host = schema.connectionProperties.host;
                            schema.isDisabledForThisSchema = false;
                            schema.selected = true;
                            data.schemas.push(schema);
                            data.hasSuperUser = true;
                        }
                        else {
                            let envSchemas = this.environments.find(m => m.id == data.id).schemas;
                            envSchemas.splice(envSchemas.findIndex(function (i) {
                                return i.id === schema.schemaId;
                            }), 1);
                            envSchemas.push(schema);
                        }
                    }
                );
            });
        }
    }

    remove(schema) {
        this.onRemoveSchema?.emit({ environment: this.selectedEnvironment, schema: schema })
    }

    envFilter = (item) => {
        if (this.selectedEnvironment != null) {
            if (item.id === this.selectedEnvironment.id && item.tempEnvId === this.selectedEnvironment.tempEnvId)
                return false
        }
        return true;
    }

    CheckingConnector($index) {
        if (this.selectedEnvironment && this.prevEnvironmentType.environments && this.prevEnvironmentType.environments[0].schemas && this.selectedEnvironment.schemas && this.selectedEnvironment.schemas[$index] && this.selectedEnvironment.schemas[$index].schemaMap) {
            let foundConnection = this.prevEnvironmentType.environments[0].schemas.find(item => item.schemaId == this.selectedEnvironment.schemas[$index].schemaMap.schemaId)
            if (!this.selectedEnvironment.schemas[$index].isSuperUser && foundConnection) {
                return true;
            }
        }
        return false;
    }


    public environmentSettings(): void {
        const onConfirm = (data) => {
            console.log(data)
        }
        const dialogData = {
            title: 'Edit Environment Settings',
            environment: this._environment,
            comparisonTypes: this.store.getState().project.comparisonTypes,
            baselineTypes: this.store.getState().project.baselineTypes
        };
        this.dialogManagerService.showDialog(dialogData, onConfirm, EnvSettingDialog, 'env-setting-dialog');
    }

    public drop(event: CdkDragDrop<{ title: string, poster: string }[]>) {
        moveItemInArray(this.environment.schemas, event.previousIndex, event.currentIndex);
    }

    handleEnvironmentClicked(environment) {
        this.selectedEnvironment = environment;
        this.onSelectEnvironment.emit(this.selectedEnvironment)

    }

    getOrderRM() {
        this.orderRMid = this.environment.schemas.filter(schema =>
            !schema.isSuperUser).map(schema => schema.schemaMap);
    }

    hasVersionToRM() {
        return this._environment && this._environment.IsRMSource && this._environment.hasVersion ? true : false;
    }

    onRemoveEnv(data) {
        if (data) {
            const onConfirm = () => {
                this.environments = this.environments.filter((env => (env.id != data.id) || (env.tempEnvId != data.tempEnvId)));
                this.selectedEnvironment = this.environments[this.environments.length - 1];
                this.onSelectEnvironment.emit(this.selectedEnvironment);
                setTimeout(() => { this.onRemoveEnvironment.emit({ env: data }); }, 1000);
            };

            const dialogData = { title: 'Delete Environment', action: 'delete', objectType: 'environment', item: data.name };
            this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
        }
    }




    setOrder(schema2Order) {
        //if (this._environment?.isRMSource || (!schames) || (schames && schames.length < 2))
        //if (this._environment?.isRMSource || (!schames))
        if (this._environment?.isRMSource)
            return schema2Order;
        if (schema2Order == null)
            schema2Order = [];
        let rightOrderSchames = [];
        //var superRm = this.rmSchemas.filter(s => s.isSuperUser)[0];
        this.rmSchemas = this.rmSchemas.filter(s => !s.isSuperUser);
        var superSchema = schema2Order.filter(s => s.isSuperUser)[0];
        schema2Order = schema2Order.filter(s => !s.isSuperUser);
        this.rmSchemas.forEach((rmSchema) => {
            let schema = schema2Order.filter(item => {
                if (item.schemaMap) {
                    return item.schemaMap.schemaId ==
                        rmSchema.scheamId && item.schemaMap.tempSchemaId == rmSchema.tempSchemaId
                }
            })[0];
            if (schema) {
                rightOrderSchames.push(schema);
            }
            else {
                rightOrderSchames.push({ "id": -1, "tempSchemaId": -1, "name": "Temp", "isSuperUser": false, "connectionProperies": "" })
            }
        });
        //if (superRm)
        //    this.rmSchemas(superRm)

        if (superSchema) {
            schema2Order.push(superSchema);
            rightOrderSchames.push(superSchema);
        }


        return rightOrderSchames;

        //return (schames.filter(s => !s.isSuperUser).length ==
        //rightOrderSchames.filter(s => !s.isSuperUser).length) ? rightOrderSchames : schames;
    }

    public isRS(): boolean {
        return this.environment.isRMSource || this.environment.id === this.ENV_TYPES.Release_Source;
    }

    public show(event): void {
        var val = null;
        //In case the tempSchemaId exists, we will search by it (it means the schema does not yet have a constant id from the server)
        if (event.tempSchemaId != null && event.tempSchemaId != 0) {
            val = this._environment.schemas.find(item => item.tempSchemaId === event.tempSchemaId);
        }
        else {
            val = this._environment.schemas.find(item => item.schemaId === event.schemaId);
        }

        this.onRemoveSchema.emit({ environment: this.selectedEnvironment, schema: val })
        //update the temp schema list after the removal
        this._environment.schemas4UIView = this.setOrder(this._environment?.schemas)?.filter(s => !s.isSuperUser);

        // this.onRemoveSchema.emit(value);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/rotatorItem/environmentsRotator/environmentsRotator.ts